/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelMeetingResponseDto,
  CreateMeetingResponseDto,
  GetMeetingResponseDto,
  GetMeetingShortResponseDto,
  MeetingRequestDto,
} from '../models/index';
import {
    CancelMeetingResponseDtoFromJSON,
    CancelMeetingResponseDtoToJSON,
    CreateMeetingResponseDtoFromJSON,
    CreateMeetingResponseDtoToJSON,
    GetMeetingResponseDtoFromJSON,
    GetMeetingResponseDtoToJSON,
    GetMeetingShortResponseDtoFromJSON,
    GetMeetingShortResponseDtoToJSON,
    MeetingRequestDtoFromJSON,
    MeetingRequestDtoToJSON,
} from '../models/index';

export interface CancelMeetingRequest {
    meetingId: string;
}

export interface CreateMeetingRequest {
    meetingRequestDto: MeetingRequestDto;
}

export interface GetMeetingRequest {
    meetingId: string;
    withParticipants?: boolean;
}

export interface GetMeetingShortenedRequest {
    meetingId: string;
    withParticipants?: boolean;
}

export interface UpdateRequest {
    meetingId: string;
    body: object;
}

/**
 * 
 */
export class WebmeetControllerApi extends runtime.BaseAPI {

    /**
     * Cancel meeting
     */
    async cancelMeetingRaw(requestParameters: CancelMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelMeetingResponseDto>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling cancelMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/{meetingId}/cancelation`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelMeetingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cancel meeting
     */
    async cancelMeeting(requestParameters: CancelMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelMeetingResponseDto> {
        const response = await this.cancelMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schedule new meeting
     */
    async createMeetingRaw(requestParameters: CreateMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMeetingResponseDto>> {
        if (requestParameters['meetingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'meetingRequestDto',
                'Required parameter "meetingRequestDto" was null or undefined when calling createMeeting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/webmeet/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeetingRequestDtoToJSON(requestParameters['meetingRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMeetingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Schedule new meeting
     */
    async createMeeting(requestParameters: CreateMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMeetingResponseDto> {
        const response = await this.createMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get full meeting info
     */
    async getMeetingRaw(requestParameters: GetMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeetingResponseDto>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling getMeeting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['withParticipants'] != null) {
            queryParameters['with-participants'] = requestParameters['withParticipants'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/{meetingId}`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeetingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get full meeting info
     */
    async getMeeting(requestParameters: GetMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeetingResponseDto> {
        const response = await this.getMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get shortened meeting info
     */
    async getMeetingShortenedRaw(requestParameters: GetMeetingShortenedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeetingShortResponseDto>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling getMeetingShortened().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['withParticipants'] != null) {
            queryParameters['with-participants'] = requestParameters['withParticipants'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/shortened/{meetingId}`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeetingShortResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get shortened meeting info
     */
    async getMeetingShortened(requestParameters: GetMeetingShortenedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeetingShortResponseDto> {
        const response = await this.getMeetingShortenedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The request body is a JSON Patch object that explains what we want to replace, insert, or delete compared to what we already have.
     * Update already existed meeting
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMeetingResponseDto>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling update().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling update().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/webmeet/{meetingId}`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMeetingResponseDtoFromJSON(jsonValue));
    }

    /**
     * The request body is a JSON Patch object that explains what we want to replace, insert, or delete compared to what we already have.
     * Update already existed meeting
     */
    async update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMeetingResponseDto> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
